import React from 'react';

export const RadioGroup = ({ value, onValueChange, className, children }) => {
  return (
    <div className={className} role="radiogroup">
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, { groupValue: value, onGroupValueChange: onValueChange });
        }
        return child;
      })}
    </div>
  );
};

export const RadioGroupItem = ({ value, id, groupValue, onGroupValueChange, className }) => {
  const isChecked = groupValue === value;
  
  return (
    <button
      type="button"
      role="radio"
      aria-checked={isChecked}
      id={id}
      className={`h-4 w-4 rounded-full border border-gray-300 ${isChecked ? 'bg-purple-600 border-purple-600' : 'bg-white'} focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${className || ''}`}
      onClick={() => onGroupValueChange(value)}
    >
      {isChecked && (
        <span className="flex items-center justify-center w-full h-full">
          <span className="w-2 h-2 bg-white rounded-full"></span>
        </span>
      )}
    </button>
  );
};